import { useState } from "react";
import { useParams } from "react-router-dom";
import { usePermissionUserOrganisations } from "../../../../../../contexts/permissions/PermissionHooks";
import { useRefreshClaims } from "../../../../../../core/auth/authorise";
import { useFlightPathUser } from "../../../../../../core/auth_insight";
import { SingleForm } from "../../../../forms/singleFormModel/SingleForm_view";
import { CopyProjectModel } from "./CopyProject_model";
import { useCurrentOrganisationId } from "../../../../../../services/local/organisationContext/OrganisationContextModel";

export const CopyProject: React.FC = () => {
  const authUser = useFlightPathUser();
  const { projectId } = useParams();
  const organisationId = useCurrentOrganisationId();
  const refreshClaims = useRefreshClaims();
  const organisations = usePermissionUserOrganisations();
  const [model] = useState(
    () => new CopyProjectModel(organisationId, +projectId, authUser, refreshClaims, organisations)
  );

  return (
    <div className="copy-projects container-fluid">
      <div className="row">
        <div className="col">
          <SingleForm model={model.formModel} />
        </div>
      </div>
    </div>
  );
};
